import store from '@/store';

export default class RefreshOrgUnitEvent {
  constructor(body) {
    store.dispatch(
      'attendance/setOrgUnitInformation',
      store.state.attendance.orgUnitInformation.id,
    );
  }
}
